import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ControlContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Label = styled.label`
  font-size: 12px;
  width: 60px;
`;

const Input = styled.input`
  width: 60px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 3px;
`;

const Button = styled.button`
  padding: 4px 8px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 3px;
  font-size: 12px;
  margin-top: 5px;
  
  &:hover {
    background-color: #555;
  }
`;

const DimensionsControl = ({ svgCode, setSvgCode }) => {
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [viewBox, setViewBox] = useState('');

  useEffect(() => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgCode, 'image/svg+xml');
      const svgElement = doc.querySelector('svg');
      
      if (svgElement) {
        setWidth(svgElement.getAttribute('width') || '');
        setHeight(svgElement.getAttribute('height') || '');
        setViewBox(svgElement.getAttribute('viewBox') || '');
      }
    } catch (err) {
      console.error('Error parsing SVG dimensions:', err);
    }
  }, [svgCode]);

  const handleApply = () => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgCode, 'image/svg+xml');
      const svgElement = doc.querySelector('svg');
      
      if (svgElement) {
        if (width) svgElement.setAttribute('width', width);
        if (height) svgElement.setAttribute('height', height);
        if (viewBox) svgElement.setAttribute('viewBox', viewBox);
        
        setSvgCode(new XMLSerializer().serializeToString(doc));
      }
    } catch (err) {
      console.error('Error updating SVG dimensions:', err);
    }
  };

  return (
    <ControlContainer>
      <InputGroup>
        <Label>Width:</Label>
        <Input 
          type="text" 
          value={width} 
          onChange={(e) => setWidth(e.target.value)}
          placeholder="width"
        />
      </InputGroup>
      
      <InputGroup>
        <Label>Height:</Label>
        <Input 
          type="text" 
          value={height} 
          onChange={(e) => setHeight(e.target.value)}
          placeholder="height"
        />
      </InputGroup>
      
      <InputGroup>
        <Label>ViewBox:</Label>
        <Input 
          type="text" 
          value={viewBox} 
          onChange={(e) => setViewBox(e.target.value)}
          placeholder="viewBox"
        />
      </InputGroup>
      
      <Button onClick={handleApply}>Apply</Button>
    </ControlContainer>
  );
};

export default DimensionsControl; 